import { Button, Modal, UIHeading1 } from '@cian/ui-kit';

import * as React from 'react';

import * as styles from './LocationDetectModal.css';

export interface ILocationDetectModalProps {
  title: string;
  onOpenChange(open: boolean): void;
  onAgree(): void;
  onRegionChange(): void;
}

export const LocationDetectModal: React.FC<ILocationDetectModalProps> = ({
  title,
  onOpenChange,
  onAgree,
  onRegionChange,
}) => {
  return (
    <Modal
      open
      data-name="LocationDetectModal"
      footer={
        <div className={styles['buttons']}>
          <Button data-name="ConfirmLocation" size="M" onClick={onAgree}>
            Да
          </Button>
          <Button data-name="ChangeLocation" size="M" theme="fill_secondary" onClick={onRegionChange}>
            Выбрать регион
          </Button>
        </div>
      }
      header={<UIHeading1>{title}</UIHeading1>}
      size="S"
      onOpenChange={onOpenChange}
    />
  );
};
